module.exports = __webpack_public_path__ + "img/image-4.166822ed.png";